import { render, staticRenderFns } from "./RefundRequestIcon.vue?vue&type=template&id=5b6cf4a5&scoped=true&"
import script from "./RefundRequestIcon.vue?vue&type=script&lang=js&"
export * from "./RefundRequestIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6cf4a5",
  null
  
)

export default component.exports